<template>
    <div class="home-root-container">
      <div class="home-header-container">
        <my-header />
        <div class="home-header-main-container">
          <span style="color: #fff; font-size: 32px; font-weight: bold"
            >灵活用工监管平台</span
          >
          <span style="color: #fff; font-size: 13px; margin-top: 10px"
            >全部交易{{ totalCount }}笔</span
          >
  
          <Input
            @keyup.enter.native="setContent"
            v-model="search_content_temp"
            prefix="ios-search"
            placeholder="搜索企业名称或个人名称"
            size="large"
            style="width: 350px; margin-top: 40px"
          />
        </div>
      </div>
  
      <div class="home-main-container">
        <div class="home-row-container">
          <span
            @click="showSearch"
            style="
              font-size: 23px;
              font-weight: bold;
              color: #15509f;
              cursor: pointer;
            "
            >{{ keyWord
            }}<span style="font-size: 23px; font-weight: bold; color: #000"
              >的交易</span
            ></span
          >
          <Icon
            type="md-close"
            :size="30"
            @click="init"
            style="cursor: pointer"
          />
          <div style="flex: 1"></div>
          <Button
            size="small"
            icon="md-calendar"
            type="text"
            @click="showTimeDrawer"
            >设置日期</Button
          >
          <span style="margin-right: 10px"
            >{{ start_time_format }}至{{ end_time_format }}</span
          >
          查看对象选择：
          <!-- 添加选项卡 -->
          <ul class="tab-list">
            <li
              :class="{ active: activeTab === 'company' }"
              @click="activeTab = 'company'"
            >
              公司
            </li>
            <li
              :class="{ active: activeTab === 'contact' }"
              @click="activeTab = 'contact'"
            >
              个人
            </li>
          </ul>
        </div>
  
        <div class="home-list-container">
          <!-- 公司相关内容 -->
          <div v-if="activeTab === 'company'">
            <div class="home-row-container" style="margin: 0 10px">
              <span style="font-size: 12px; font-weight: bold">最近的付款</span>
              <div style="flex: 1"></div>
              <span
                @click="showSearchResult(0)"
                style="color: #417da6; font-size: 12px; cursor: pointer"
                >查看全部</span
              >
            <span style="font-size: 12px; margin-left: 20px">
            统计时间段：{{ start_time_format }}至{{ end_time_format }} 总金额：{{ totalCompanyAmount.toLocaleString() }}元
            </span>
            </div>
            <trade-item
              v-for="item in tradeCompanyList"
              :key="item.card_log_id"
              :data-source="item"
            />
          </div>
  
          <!-- 个人相关内容 -->
          <div v-if="activeTab === 'contact'">
            <div class="home-row-container" style="margin: 0 10px">
              <span style="font-size: 12px; font-weight: bold">最近的用工相关</span>
              <div style="flex: 1"></div>
              <span
                @click="showSearchResult(1)"
                style="color: #417da6; font-size: 12px; cursor: pointer"
                >查看全部</span
              >
              <span style="font-size: 12px; margin-left: 20px">
                统计时间段：{{ start_time_format }}至{{ end_time_format }} 总金额：{{ totalContactAmount.toLocaleString() }}元
              </span>
            </div>
            <trade-item
              v-for="item in tradeContactList"
              :key="item.card_log_id"
              :data-source="item"
            />
          </div>
        </div>
      </div>
  
      <time-drawer ref="timeDrawer" @setTime="setTime" />
      <search-modal ref="searchModal" @search="search" />
      <search-result-modal ref="searchResultModal" />
    </div>
  </template>
  
  <script>
  import { mapActions, mapState, mapGetters } from "vuex";
  import moment from "moment";
  import * as _ from "lodash";
  import Header from "./Header";
  import * as icon from "../../common/icon";
  import TimeDrawer from "./Drawer/TimeDrawer";
  import SearchModal from "./Modal/SearchModal";
  import SearchResultModal from "./Modal/SearchResultModal";

  export default {
    name: "Home",
    components: {
      "my-header": Header,
      "time-drawer": TimeDrawer,
      "search-modal": SearchModal,
      "search-result-modal": SearchResultModal,
    },
    data() {
      return {
        icons: icon,
        tradeCompanyList: [],
        tradeContactList: [],
        totalCount: 0,
        totalCompanyAmount: 0, // 公司总金额
        totalContactAmount: 0, // 个人总金额
        searchForm: {
          type: 1,
          search_content: "",
          search_content_format: "",
          start_time: localStorage.getItem("start_time") || moment().startOf('year').toISOString(), // 默认当前自然年
          end_time: localStorage.getItem("end_time") || moment().endOf('year').toISOString(), // 默认当前自然年
          page_size: 25,
          page_index: 0,
        },
        search_content_temp: "",
        activeTab: "company", 
      };
    },
    mounted() {
      this.activeTab = this.searchForm.type === 3 ? "contact" : "company";

      this.$Notice.config({
        duration: 0,
      });
  
      this.tradeGetTotalCountAction()
        .then((res) => {
          this.totalCount = res;
        })
        .catch((error) => {
          this.$Message.error(error);
        });
  
      this.getList();
    },
    watch: {
        "searchForm.type": function (newType) {
            // 当 searchForm.type 变化时，更新 activeTab
            this.activeTab = newType === 3 ? "contact" : "company";
        },
    },    
    computed: {       
      start_time_format() {
        let result = moment(this.searchForm.start_time).format("YYYY年MM月DD日");
        return result == "Invalid date" ? "-" : result;
      },
      end_time_format() {
        let result = moment(this.searchForm.end_time).format("YYYY年MM月DD日");
        return result == "Invalid date" ? "-" : result;
      },
      keyWord() {
        if (this.searchForm.type == 1) {
          if (this.searchForm.search_content == "") {
            return "全部用户";
          }
          return this.searchForm.search_content;
        } else if (this.searchForm.type == 2) {
          return this.searchForm.search_content_format;
        } else if (this.searchForm.type == 3) {
          return this.searchForm.search_content_format;
        }
      },
    },
    methods: {
      ...mapActions({
        tradeGetTotalCountAction: "tradeGetTotalCount",
        tradeGetListAction: "tradeGetList",
        tradeGetListByCompanyAction: "tradeGetListByCompany",
        tradeGetListByContactAction: "tradeGetListByContact",
        tradeGetTotalAmountAction: "tradeGetTotalAmount"
      }),
      showSearch() {
        this.$refs.searchModal.open(0);
      },
      showSearchResult(tab) {
        this.$refs.searchResultModal.open(this.searchForm, tab);
      },
      showTimeDrawer() {
        this.$refs.timeDrawer.open(
          this.searchForm.start_time,
          this.searchForm.end_time
        );
      },
      setTime(obj) {
        this.searchForm.start_time = obj.start_time;
        this.searchForm.end_time = obj.end_time;
        localStorage.setItem("start_time", this.searchForm.start_time); // 存储到 localStorage
        localStorage.setItem("end_time", this.searchForm.end_time); // 存储到 localStorage
        this.getList();
      },
      init() {
        this.searchForm.type = 1;
        this.searchForm.search_content = "";
        this.searchForm.start_time = moment().startOf('year').toISOString(); // 重置为当前自然年
        this.searchForm.end_time = moment().endOf('year').toISOString(); // 重置为当前自然年
        localStorage.removeItem("start_time"); // 清除 localStorage
        localStorage.removeItem("end_time"); // 清除 localStorage
        this.getList();
      },
      setContent() {
        this.searchForm.type = 1;
        this.searchForm.search_content = this.search_content_temp;
        this.getList();
      },
      getList() {
        let params = Object.assign(this.searchForm, {
          start_time: moment(this.searchForm.start_time).format(
            "YYYY-MM-DD 00:00:00"
          ),
          end_time: moment(this.searchForm.end_time).format(
            "YYYY-MM-DD 23:59:59"
          ),
        });
        this.tradeGetListByCompanyAction(params)
          .then((res) => {
            for (let item of res.data) {
              item.create_time = moment(item.create_time).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            this.tradeCompanyList = res.data;
          })
          .catch((error) => {
            this.$Message.error(error);
          });
        this.tradeGetListByContactAction(params)
          .then((res) => {
            for (let item of res.data) {
              item.create_time = moment(item.create_time).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            this.tradeContactList = res.data;
          })
          .catch((error) => {
            this.$Message.error(error);
          });

        // 调用 getTotalAmount 接口，传入 start_time 和 end_time
        this.tradeGetTotalAmountAction(params)
        .then((res) => {
            this.totalCompanyAmount = res.companyTotalAmount || 0;
            this.totalContactAmount = res.contactTotalAmount || 0;
        })
        .catch((error) => {
            this.$Message.error(error);
        });
      },
      search(obj) {
        this.searchForm.type = obj.type;
        this.searchForm.search_content = obj.search_content;
        this.searchForm.search_content_format = obj.search_content_format;
        this.getList();
      },
    },
  };
  </script>
  
  <style scoped>
  .home-root-container {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: #f8f8f8;
    overflow-y: scroll;
  }
  .home-header-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 350px;
    min-height: 350px;
    background-color: #2b303b;
  }
  .home-header-main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
  }
  .home-main-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1;
    padding: 50px 200px;
  }
  .home-row-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .home-list-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 30px;
  }
  /* 添加选项卡样式 */
  .tab-list {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .tab-list li {
    padding: 10px 20px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
  }
  .tab-list li.active {
    border-bottom: 2px solid #15509f;
    font-weight: bold;
  }
  </style>